import React, { } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

import { ButtonLink } from '../utils/Button'
import Card from '../utils/Card'

import { MARKETING } from '../../utils/constants'

const ListItem = ({ level }) => {
  return MARKETING.points[level].map((item, i) => (
    <div key={i} className="text-lg ">
      <FontAwesomeIcon icon={faCheck} className="mr-2 text-green-500" />
      {item}
    </div>
  ))
}

const PremiumCTA = () => {
  return (
    <Card className="mt-4">
      <div className="prose prose-lg mb-8">
        <h3 className="">Premium Membership</h3>
        <p>Becoming a WanderingLabs Premium Member gets you these benefits:</p>
      </div>

      <ListItem level="upgrade" />

      <div className="mt-12">
        <ButtonLink to="/premium" color="darkGreen" className="text-2xl">
          Go Premium
        </ButtonLink>
      </div>
    </Card>
  )
}

export default PremiumCTA
